import { createServerFn } from '@tanstack/react-start'

import type {
  HeroSlide,
  CoreValue,
  MenuItem,
  MenuCategory,
  Review,
  TeamMember,
  BlogPost,
  BusinessHours,
  SiteConfig,
  ServiceInfo,
  BakeryStat,
  PageHeader,
  GalleryImage,
} from './content-types'

import heroSlides from '../content/hero-slides.json'
import coreValues from '../content/core-values.json'
import menuItems from '../content/menu-items.json'
import menuCategories from '../content/menu-categories.json'
import reviews from '../content/reviews.json'
import teamMembers from '../content/team-members.json'
import blogPosts from '../content/blog-posts.json'
import hours from '../content/hours.json'
import siteConfig from '../content/site-config.json'
import servicesInfo from '../content/services-info.json'
import bakeryStats from '../content/bakery-stats.json'
import pageHeaders from '../content/page-headers.json'
import galleryImages from '../content/gallery-images.json'

export const getHeroSlides = createServerFn({ method: 'GET' }).handler(
  async () => heroSlides as HeroSlide[],
)

export const getCoreValues = createServerFn({ method: 'GET' }).handler(
  async () => coreValues as CoreValue[],
)

export const getMenuItems = createServerFn({ method: 'GET' }).handler(
  async () => menuItems as MenuItem[],
)

export const getMenuCategories = createServerFn({ method: 'GET' }).handler(
  async () => menuCategories as MenuCategory[],
)

export const getReviews = createServerFn({ method: 'GET' }).handler(
  async () => reviews as Review[],
)

export const getTeamMembers = createServerFn({ method: 'GET' }).handler(
  async () => teamMembers as TeamMember[],
)

export const getBlogPosts = createServerFn({ method: 'GET' }).handler(
  async () => blogPosts as BlogPost[],
)

export const getHours = createServerFn({ method: 'GET' }).handler(
  async () => hours as BusinessHours[],
)

export const getSiteConfig = createServerFn({ method: 'GET' }).handler(
  async () => siteConfig as SiteConfig,
)

export const getServicesInfo = createServerFn({ method: 'GET' }).handler(
  async () => servicesInfo as ServiceInfo[],
)

export const getBakeryStats = createServerFn({ method: 'GET' }).handler(
  async () => bakeryStats as BakeryStat[],
)

export const getPageHeaders = createServerFn({ method: 'GET' }).handler(
  async () => pageHeaders as PageHeader[],
)

export const getGalleryImages = createServerFn({ method: 'GET' }).handler(
  async () => galleryImages as GalleryImage[],
)
